var map = {
	"./AchillesArmor.png": 87066,
	"./AmuletOfKhepri.png": 62142,
	"./AnubisSarcophagus.png": 48008,
	"./ArabianOstrichEggContainer.png": 70786,
	"./BloodlettingStingraySpine.png": 40455,
	"./BonnysBlade.png": 25521,
	"./BronzeDromedaryStatue.png": 17369,
	"./BronzeShellCoins.png": 28222,
	"./BustOfMarcusAurelius.png": 66024,
	"./CaptainsHat.png": 8494,
	"./CorsairsSkull.png": 36095,
	"./DrakesFirearm.png": 25600,
	"./EccentricFlint.png": 21735,
	"./EchoesOfTheNorth.png": 51948,
	"./FoundationsOfCivilization.png": 76902,
	"./GoddessOfFertility.png": 2294,
	"./HeadOfTheTrojanHorse.png": 44551,
	"./HelensDress.png": 88086,
	"./HiddenHoard.png": 16178,
	"./HobbleOfTheSea.png": 21557,
	"./IdolOfBastet.png": 92382,
	"./IlkhanicTables.png": 88298,
	"./JollyRoger.png": 5749,
	"./KeyOfLife.png": 75612,
	"./KingPakalMask.png": 18604,
	"./LegendsOfTheHighSeas.png": 99600,
	"./LegendsOfTroy.png": 94327,
	"./LoongSymbol.png": 47811,
	"./LotusShoes.png": 89725,
	"./MayaCodexOfMexico.png": 94447,
	"./NebraDisc.png": 65367,
	"./NorseHoard.png": 38411,
	"./PathsOfIncense.png": 66190,
	"./PharaosGold.png": 810,
	"./PriamsDiadem.png": 94094,
	"./ProwOfVinland.png": 96421,
	"./QueenArwaDinar.png": 56727,
	"./RavenHelm.png": 8258,
	"./StringsOfTheAncients.png": 94519,
	"./StringsOfTheSkald.png": 73977,
	"./SwordOfHector.png": 74995,
	"./TheArtOfChaDao.png": 99555,
	"./ToolsOfTheFirstBuilders.png": 85391,
	"./TorpedoJar.png": 81714,
	"./TragedyAndComedy.png": 10566,
	"./TreasuresOfTheNile.png": 52698,
	"./UnderTheCeiba.png": 79919,
	"./VesselOfAthena.png": 55662,
	"./WarriorsCrown.png": 39506,
	"./WeaponsOfValhalla.png": 44045,
	"./WhispersOfJade.png": 41454,
	"./WhispersOfTheInk.png": 35627,
	"./XocolatlDrinkingCup.png": 47558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23861;